import React from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';

import {Icon, Btn} from '../../../../ui-toolkit';

function Paging({loadMore, totalCount, currentCount, t}) {
    return (
        <Wrapper color="primary" onClick={loadMore} type="button">
            <Icon type="sm" name="MoreVert" />
            {t('paging.loadMore', {
                showing: currentCount,
                total: totalCount,
            })}
        </Wrapper>
    );
}
export default withTranslation()(Paging);

const Wrapper = styled(Btn)`
    margin-bottom: 4px;
`;
